/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import styled from 'styled-components';
import tw from 'twin.macro';

export type ButtonBarItem = {
  label: string;
  value: string;
};

type ButtonBarPropTypes = {
  items: ButtonBarItem[];
  register: UseFormRegisterReturn;
  validation?: FieldError;
  onChange?: (item: ButtonBarItem) => void;
  compact?: boolean;
};

const ButtonBarStyled = styled.div`
  input {
    width: 1px;
    height: 1px;
    visibility: hidden;
    position: absolute;
  }

  input:checked + label {
    ${tw`bg-blue-100 border-blue-100 text-black`}
  }
`;

export default function ButtonBar({
  items,
  register,
  validation,
  onChange,
  compact = false,
}: ButtonBarPropTypes): JSX.Element {
  const { onChange: registerOnChange, ...restRegister } = register;
  // Compact variant avoids the `.btn` utility so the smaller padding actually
  // applies (`.btn` lives in @layer utilities and would otherwise win).
  const labelClassName = compact
    ? 'text-white flex border border-gray-200 text-gray-200 rounded-md px-3 py-1 text-sm cursor-pointer transition-all ease-in-out duration-200 hover:text-black hover:bg-gray-200'
    : 'text-white flex btn btn--secondary-outline';
  return (
    <ButtonBarStyled>
      <div className={`wrapper inline-flex flex-wrap flex-row ${compact ? 'mt-0' : 'mt-3'}`}>
        {items.map((item) => (
          <div
            className={`radio-wrapper self-start ${compact ? 'mr-2 mb-2' : 'mr-3 mb-5'}`}
            key={item.value}>
            <input
              {...restRegister}
              id={`${register.name}-${item.value}`}
              type="radio"
              onChange={(e) => {
                registerOnChange(e);
                if (onChange) {
                  onChange(item);
                }
              }}
              value={item.value}
            />
            <label className={labelClassName} htmlFor={`${register.name}-${item.value}`}>
              {item.label}
            </label>
          </div>
        ))}
      </div>
      {validation && <div className="text-red-500 my-5">Please select a movie date</div>}
    </ButtonBarStyled>
  );
}
